export const custStep1 = {
  userId: "272",
  threadId: "2254",
  step: 4,
  status: "Pending",
  prompt:
    "✅ Based on your uploads, I've mapped relevant columns to core signals: \n\n- Including Hidden Value \n\n- Early Churn Risk \n\n- Promo Inefficiency \n\n- Identity Fragmentation.\n\n Feel free to review or refine the mapping on the right panel. ",
  user_input: "ch marketing channels convert best for dormant users",
  response:
    "Thank you for your input. Here's the mission-critical question you've provided:\n\n1. Which marketing channels convert best for dormant users?\n\nCould you please provide 1–2 more essential questions you want the report to answer?",
  json_response: {
    "engagement_logs_q1.csv": {
      user_id: {
        label: "Account User ID",
        signal_type: "Identifier",
        notes: "Common join key across datasets",
      },
      watch_time_seconds: {
        label: "Content Watch Duration",
        signal_type: "Stickiness Signal",
        notes: "Used in churn prediction and retention modeling",
      },
      dropoff_pct: {
        label: "Episode Dropoff Percentage",
        signal_type: "Fatigue Indicator",
        notes: "Key for content fatigue and engagement drop tracking",
      },
      content_type: {
        label: "Content Format Type",
        signal_type: "Engagement Signal",
        notes: "e.g., Playlists, Shorts, Long-form videos",
      },
      topic_tag: {
        label: "Topic or Genre Tag",
        signal_type: "Interest Signal",
        notes: "Useful for upsell targeting and personalization",
      },
      view_completion_flag: {
        label: "Completion Flag",
        signal_type: "Attention Depth",
        notes: "Binary for finished vs abandoned content",
      },
    },
    "user_profiles_q1.csv": {
      user_id: {
        label: "Account User ID",
        signal_type: "Identifier",
        notes: "Primary key for joining user-related data",
      },
      signup_date: {
        label: "Signup Date",
        signal_type: "Lifecycle Signal",
        notes: "Used to calculate account age and cohort",
      },
      subscription_type: {
        label: "Subscription Tier",
        signal_type: "Revenue Signal",
        notes: "Indicates user's payment level",
      },
      last_login_date: {
        label: "Last Login Date",
        signal_type: "Engagement Recency",
        notes: "Useful for active user segmentation",
      },
      region: {
        label: "Geographic Region",
        signal_type: "Demographic Signal",
        notes: "Used for localization and A/B testing",
      },
    },
    "feedback_logs_q1.csv": {
      user_id: {
        label: "Account User ID",
        signal_type: "Identifier",
        notes: "Join key to map feedback to users",
      },
      content_id: {
        label: "Content Identifier",
        signal_type: "Content Signal",
        notes: "Tracks which content feedback is related to",
      },
      feedback_score: {
        label: "User Feedback Score",
        signal_type: "Satisfaction Signal",
        notes: "Scale from 1–5 or 1–10, used in NPS analysis",
      },
      feedback_comment: {
        label: "Free-text Feedback",
        signal_type: "Sentiment Input",
        notes: "Optional user notes, useful for NLP",
      },
      submitted_at: {
        label: "Feedback Timestamp",
        signal_type: "Temporal Signal",
        notes: "Indicates when feedback was submitted",
      },
    },
  },
  status_main: false,
  type_json: "Auto_mapper_field",
};

export const custStep2 = {
  userId: "272",
  threadId: "2254",
  step: 4,
  status: "Pending",
  prompt:
    `✅ Here's a snapshot of your data integrity and signal quality.
  This helps determine: \n\n- Which Layers Will Power Segmentation \n\n- Churn Prediction \n\n- Value Forecasting.\n\n You can proceed with default data treatments, or customize how we handle gaps, outliers, and schema quirks.`,
  user_input: "ch marketing channels convert best for dormant users",
  response:
    "Thank you for your input. Here's the mission-critical question you've provided:\n\n1. Which marketing channels convert best for dormant users?\n\nCould you please provide 1–2 more essential questions you want the report to answer?",
  json_response: [
    {
      message: "Core Join Keys Detected: user_id, account_id, timestamp",
      status: "success",
    },
    {
      message: "Seat Data Aligned: licensed_seats + active_seats found across 90% of rows",
      status: "success",
    },
    {
      message: "Missing Fields: 3.7% of entries in watch_time_min → Suggested: mean or median fill",
      status: "warning",
    },
    {
      message: "Outliers: Drop-off rates >90% for 1.4% of content — Suggest: soft clipping",
      status: "warning",
    },
    {
      message:
        "NPS Feedback Aligned to Timestamps: Over 82% of NPS scores linked to valid activity windows",
      status: "success",
    },
    {
      message:
        "Sentiment Parsing Lag: 6.1% of open-text comments unstructured — NLP flagging applied",
      status: "warning",
    },
  ],
  status_main: false,
  type_json: "checklist",
};

export const custStep3 = {
  userId: "272",
  threadId: "2254",
  step: 4,
  status: "Pending",
  prompt: "Let's confirm your final analysis objective so I can calibrate segmentation, churn, and forecasting layers appropriately.",
  user_input: "ch marketing channels convert best for dormant users",
  response:
    "Thank you for your input. Here's the mission-critical question you've provided:\n\n1. Which marketing channels convert best for dormant users?\n\nCould you please provide 1–2 more essential questions you want the report to answer?",
  json_response: {},
  status_main: false,
  type_json: "auto_filled_summary",
};

export const custStep4 = {
  userId: "272",
  threadId: "2254",
  step: 4,
  status: "Pending",
  prompt: "Before generating your intelligence report, here’s a preview of the modeling layers I’ll activate. These are tailored to detect risk, forecast growth, and trace seat-level engagement trends across your enterprise accounts.",
  user_input: "ch marketing channels convert best for dormant users",
  response:
    "Thank you for your input. Here's the mission-critical question you've provided:\n\n1. Which marketing channels convert best for dormant users?\n\nCould you please provide 1–2 more essential questions you want the report to answer?",
  json_response: {},
  status_main: false,
  type_json: "summary_panel",
};


export const initStep1 = {
  userId: "272",
  threadId: "2254",
  step: 4,
  status: "Pending",
  "prompt": `
   👋 Welcome to LTV Agent
   Lets start by understanding your business context. What industry are you in?

### What customer-related challenges would you like to focus on?

Just pick your goals below (or type your own):
\n1. Retail Banking\n
\n2. Grocery Retail\n
\n3. B2B SaaS\n
\n4. Consumer Products\n
\n5. Healthcare\n
\n6. Manufacturing\n
\n7. Hospitality & Travel\n`,
  "json_datasources": {},
  user_input: "ch marketing channels convert best for dormant users",
  response:
    "Thank you for your input. Here's the mission-critical question you've provided:\n\n1. Which marketing channels convert best for dormant users?\n\nCould you please provide 1–2 more essential questions you want the report to answer?",
  json_response: {},
  status_main: false,
}

export const initStep2 = {
  userId: "272",
  threadId: "2254",
  step: 4,
  status: "Pending",
  prompt: `And what use cases or client teams are you most focused on improving?
   \ne.g. Internal Comms at global HQs, L&D departments with poor completion rates, Renewal-blocking disengagement, Reactivating APAC region.`,
  user_input: "",
  response:
    "Thank you for your input. Here's the mission-critical question you've provided:\n\n1. Which marketing channels convert best for dormant users?\n\nCould you please provide 1–2 more essential questions you want the report to answer?",
  json_response: {},
  status_main: false,
}


export const fileuploadresp = {
  "userId": "272",
  "threadId": "3740",
  "step": 13,
  "status": "Pending",
  "prompt": "{\"pitchdeck_summary\":\"{\\\"documents\\\":[{\\\"filename\\\":\\\"user_data (3).csv\\\",\\\"content\\\":\\\"### Summary of Document\\\\n\\\\n1. **Technical Issues**:\\\\n   - Users report frequent app crashes, freezing issues, and slow login times post-update (e.g., app freezing during transactions or check deposits).\\\\n   - Dashboard widgets not loading and balance inconsistencies after transactions are highlighted.\\\\n   - These concerns are frequently escalated or generate frustration, with a sentiment score range of -0.30 to -0.88.\\\\n\\\\n2. **Complaints**:\\\\n   - Hidden or unclear fees, misleading APY, and discrepancies in advertised benefits are recurring issues.\\\\n   - Users feel misled about interest rates and promotional offers, leading to anger and dissatisfaction.\\\\n   - Several complaints reference delayed or ignored responses to previous inquiries, causing service dissatisfaction.\\\\n\\\\n3. **Query Themes**:\\\\n   - Common queries involve product visibility (e.g., finding savings goals, statement settings, and specific features like direct deposit forms or \\\\\\\"pay friends\\\\\\\").\\\\n   - Users also seek clarity on reward points, hidden fees, bonus programs, and tiered APY.\\\\n\\\\n4. **Escalations**:\\\\n   - Escalated cases often center around technical malfunctions, fee disputes, and unmet expectations regarding interest rates or account terms.\\\\n\\\\n5. **Emotional Sentiment**:\\\\n   - Overall sentiment skews negative, with frustration and anger dominating (sentiment scores ranging from -0.20 to -0.95).\\\\n\\\\n\\\"}]}\"}",
  "response": "Thank you for uploading the pitch deck summary!\n\nNow, let's proceed to the next step.\n\n## Upload Review & Validation Flow\n\nHere’s a snapshot of everything you uploaded. Please confirm to proceed.\n\nTable displayed on right side\n\nPlease confirm if this information is correct or let me know if any adjustments are needed. Once confirmed, we can proceed with the analysis.\n\n@@Confirm@@",
  "json_response": [
    "\n  • Filename: user_data (3).csv\n  • Category: Pitch Deck\n  • Size/Rows: Summary of Document\n  • Format: CSV\n  • Status: Ready\n"
  ],
  "status_main": false,
  "type_json": "review_and_validation"
}

export const quickHealth = {
  "userId": "272",
  "threadId": "3712",
  "step": 14,
  "status": "Pending",
  "prompt": "Proceed further",
  "response": "Thank you for confirming.\n\nNow, let's move on to the QuickHealth Checklist.\n\n## A Quick Health analysis has been performed on the data you uploaded. This provides a rapid snapshot of completeness, format consistency, and obvious errors. You can view the results in the right-side panel before moving on to deeper validation.\n\nIf everything looks good, please select @@Continue@@ to proceed.",
  "json_response": {
    "title": "🎯 Schema Validation & Signal Quality Audit",
    "summary": "Analyzed 2 files: `user_data%20%283%29.csv` and `file-sample_150kB%20%281%29.pdf`. Key signals include sentiment scores, intent distribution, emotion breakdown, and reply status trends. The dataset primarily highlights user dissatisfaction and unresolved issues.",
    "findings": [
      {
        "type": "success",
        "text": "✅ No null values detected in `user_data%20%283%29.csv`."
      },
      {
        "type": "success",
        "text": "✅ No duplicate rows identified in `user_data%20%283%29.csv`."
      },
      {
        "type": "warning",
        "text": "⚠️ Sentiment score extremes (e.g., -0.95) indicate severe user dissatisfaction in `user_data%20%283%29.csv`."
      },
      {
        "type": "warning",
        "text": "⚠️ Prolonged unresolved issues (e.g., `no_reply`) appear frequently despite escalations or complaints in `user_data%20%283%29.csv`."
      },
      {
        "type": "warning",
        "text": "⚠️ High `ignored` or `not_replied` rates for complaints (`no_reply` issues) in `user_data%20%283%29.csv`."
      },
      {
        "type": "warning",
        "text": "⚠️ Outliers detected: Extremely low sentiment scores (e.g., -0.95) in complaint-related messages in `user_data%20%283%29.csv`."
      }
    ]
  },
  "status_main": false,
  "type_json": "quick_health"
}

export const schemaValidation = {
  "userId": "272",
  "threadId": "3712",
  "step": 15,
  "status": "Pending",
  "prompt": "Proceed further",
  "response": "Great! Let's move on to the Schema Validation.\n\n## The files you uploaded have been analyzed and field-level diagnostics have been performed. You should see the results (dataset coverage, outliers, and notes) in the right-side panel. Please review these diagnostics carefully and confirm that they look correct before we proceed to the Proposed Cleanup Plan.\n\nPlease take your time to review and let me know if everything looks correct!",
  "json_response": {},
  "status_main": false,
  "type_json": "schema_validation_field_level_diagnostic"
}

export const proposedCleanup = {
  "userId": "272",
  "threadId": "3712",
  "step": 16,
  "status": "Pending",
  "prompt": "Proceed further",
  "response": "Perfect! Let's move on to the Proposed Cleanup Plan.\n\n## On the right side, you’ll see a list of recommended cleanup options (normalization, harmonization, deduplication, compliance checks, etc.). Each option has a simple ON/OFF toggle with smart defaults already applied. These adjustments affect how the data is displayed in visuals and summaries, while the raw data always remains preserved in the appendix.\n\nPlease review and adjust the toggles as needed, and then confirm to proceed to the next step.",
  "json_response": [
    {
      "name": "Currency & Unit Normalization",
      "description": "FX: map EUR→USD (annual avg of report year). Units: convert k$ to $",
      "default": 1
    },
    {
      "name": "Date Harmonization",
      "description": "Convert all dates to ISO YYYY-MM-DD; infer month-end when only MMM-YY provided",
      "default": 1
    },
    {
      "name": "Outlier Handling",
      "description": "IQR-based soft caps on growth and deal size; raw values still available in appendix",
      "default": 1
    },
    {
      "name": "OSINT Canonicalization",
      "description": "Dedupe press/review links by canonical URL + title + date; drop exact duplicates",
      "default": 1
    },
    {
      "name": "Review Text Prep",
      "description": "Light cleaning (lowercasing, emoji strip), language detection, EN translation for non-EN (store original)",
      "default": 1
    },
    {
      "name": "PII & Compliance Guardrails",
      "description": "Mask emails/phones if they appear in free-text fields; preserve in designated columns only",
      "default": 1
    }
  ],
  "status_main": false,
  "type_json": "proposed_cleanup"
}

export const proposedVisuals ={
    "userId": "272",
    "threadId": "3751",
    "step": 17,
    "status": "Pending",
    "prompt": "Confirm",
    "response": "Thank you for confirming the cleanup plan.\n\n### Preview Visuals\n\nHere is a visual snapshot of the validated and cleaned data. Please review the visuals to ensure they match your expectations before we proceed.\n\nPlease refer to the right side.\n\nPlease review these visuals and confirm if they look good to proceed. If you need any adjustments, let me know!\n\n@@Confirm@@",
    "json_response": [
        "visuals:[{visual_name:\"Bar Chart\",reason:\"To display the distribution of key metrics across different segments.\"},{visual_name:\"Pie Chart\",reason:\"To show the proportion of various categories within the data.\"},{visual_name:\"Line Chart\",reason:\"To illustrate trends over time in key performance indicators.\"},{visual_name:\"Table Summary\",reason:\"To provide a detailed overview of the cleaned and validated data.\"}]"
    ],
    "status_main": false,
    "type_json": "proposed_visuals"
}

export const objectiveConfirmation = {
  "userId": "272",
  "threadId": "3712",
  "step": 18,
  "status": "Pending",
  "prompt": "Proceed further",
  "response": "Thank you for confirming.\n\nNow, let's move on to the Objective Confirmation.\n\n### Purpose: Allow the user to view and update their objective's percentage. \n\nCurrently, your objectives and their percentages are:\n1. Validate market size & growth assumptions: 10%\n2. Assess product moat & differentiation: 10%\n\nIf you would like to update these percentages, please let me know the new values. If everything looks correct, please select @@Continue@@ to proceed.",
  "json_response": [
    {
      "id": 37,
      "name": "Assess product moat & differentiation",
      "percentage": 10
    },
    {
      "id": 36,
      "name": "Validate market size & growth assumptions",
      "percentage": 10
    }
  ],
  "status_main": false,
  "type_json": "objective_confirmation"
}

export const dataSourcesInvestment = {
  "userId": "272",
  "threadId": "3712",
  "step": 19,
  "status": "Pending",
  "prompt": "Proceed further",
  "response": "Thank you for confirming.\n\nNow, let's move on to the Showcase Data Sources step.\n\nBased on the details gathered, here are some suggested search queries to help you gather more information:\n\n\nRefer to the right-hand side for further details\n\n\nPlease review these search queries and let me know if they look good or if you would like to add or suggest others.\n\nIf everything looks correct, please select @@Confirm@@ to proceed.",
  "json_response": {
    "External sources": "{\"Website\": [\"https://www.mordorintelligence.com/industry-reports/ai-infrastructure-market\", \"https://www.grandviewresearch.com/industry-analysis/ai-infrastructure-market-report\", \"https://www.marketsandmarkets.com/Market-Reports/ai-infrastructure-market-38254348.html\", \"https://www.precedenceresearch.com/artificial-intelligence-infrastructure-market\", \"https://www.polarismarketresearch.com/industry-analysis/ai-infrastructure-market\", \"https://www.fortunebusinessinsights.com/ai-infrastructure-market-110456\", \"https://marnoa.ca/ai-infrastructure-investment-trends-market-analysis-hyperscalers/\", \"https://cloud.google.com/resources/content/state-of-ai-infrastructure\", \"https://iot-analytics.com/leading-generative-ai-companies/\", \"https://www.jll.com/en-ca/insights/market-outlook/data-center-outlook\", \"https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/the-top-trends-in-tech\", \"https://www.raiaai.com/blogs/revolutionizing-healthcare-harnessing-vertical-ai-agents-for-advanced-patient-care\", \"https://www.mindbowser.com/vertical-ai-agents-transforming-healthcare-operations/\", \"https://www.bvp.com/atlas/part-iv-ten-principles-for-building-strong-vertical-ai-businesses\", \"https://www.lindy.ai/blog/vertical-ai-agents\", \"https://www.greenfield-growth.com/blog-posts/vertical-ai-is-here-how-to-capture-the-opportunity-and-win-big\", \"https://www.blueprism.com/resources/blog/the-future-of-ai-in-healthcare/\", \"https://www.iqvia.com/blogs/2024/02/the-future-of-ai-in-healthcare\", \"https://www.mckinsey.com/industries/healthcare/our-insights/generative-ai-in-healthcare-current-trends-and-future-outlook\", \"https://www.weforum.org/stories/2025/08/ai-transforming-global-health/\", \"https://mcpress.mayoclinic.org/healthy-aging/ai-in-healthcare-the-future-of-patient-care-and-health-management/\", \"https://www.philips.com/a-w/about/news/archive/features/2024/10-healthcare-technology-trends-for-2025.html\", \"https://www.pwc.com/gx/en/issues/business-model-reinvention/how-we-care-for-ourselves/future-of-care-healthcare-ecosystem.html\", \"https://qubit.capital/blog/how-to-raise-money-for-ai-startup\", \"https://www.dealmaker.tech/content/the-essential-ai-startup-funding-guide-2025-strategies-for-success\", \"https://www.pitchdrive.com/academy/guide-how-to-get-pre-seed-funding-for-startups\", \"https://aventis-advisors.com/ai-valuation-multiples/\", \"https://aifund.ai/build-with-us/\", \"https://www.zeni.ai/blog/pre-seed-funding-vs-seed-funding\", \"https://lookai.vc/\", \"https://carta.com/data/ai-fundraising-trends-2024/\", \"https://www.vcsheet.com/sheet/ai-funds\", \"https://www.goingvc.com/post/decoding-pre-seed-and-seed-funding-a-comprehensive-guide-for-entrepreneurs\", \"https://www.hubspot.com/startups/fundraising/preseed-vs-seed-funding\", \"https://www.brex.com/spend-trends/startup/pre-seed-vs-seed-funding-round\"],\"Publication\": [\"https://www.grandviewresearch.com/press-release/global-ai-infrastructure-market\", \"https://my.idc.com/getdoc.jsp?containerId=prUS52758624\", \"https://www.spglobal.com/market-intelligence/en/news-insights/research/ai-infrastructure-trends-thoughts-and-a-2025-research-agenda\", \"https://www.statista.com/outlook/tmo/artificial-intelligence/worldwide\", \"https://www.ifminvestors.com/news-and-insights/thought-leadership/ai-at-a-crossroads/\", \"https://medium.com/@kbulusu/vertical-ai-integration-in-healthcare-a-strategic-guide-for-innovation-and-advancement-14ab686fde31\", \"https://pmc.ncbi.nlm.nih.gov/articles/PMC5819974/\", \"https://pmc.ncbi.nlm.nih.gov/articles/PMC8285156/\", \"https://learn.hms.harvard.edu/insights/all-insights/how-emerging-trends-ai-are-shaping-future-health-care-quality-and-safety\", \"https://healthtechmagazine.net/article/2024/10/ai-in-healthcare-how-its-used-future-perfcon\", \"https://www.crescendo.ai/news/latest-vc-investment-deals-in-ai-startups\", \"https://eqvista.medium.com/pre-seed-valuation-models-choosing-the-right-approach-for-your-startup-e829c715c3a8\", \"https://unshackledvc.substack.com/p/ai-investing-trends-report-what-founders\", \"https://signal.nfx.com/investor-lists/top-ai-pre-seed-investors\"],\"Scholar\": [\"https://pmc.ncbi.nlm.nih.gov/articles/PMC5819974/\", \"https://pmc.ncbi.nlm.nih.gov/articles/PMC8285156/\"],\"News\": [\"https://hitconsultant.net/2025/05/06/vertical-interconnected-clouds-the-right-prescription-for-smarter-ai-driven-healthcare/\", \"https://www.definitivehc.com/blog/6-ways-ai-is-transforming-healthcare\", \"https://healthtechmagazine.net/article/2025/01/overview-2025-ai-trends-healthcare\", \"https://www.weforum.org/stories/2025/08/ai-transforming-global-health/\", \"https://mcpress.mayoclinic.org/healthy-aging/ai-in-healthcare-the-future-of-patient-care-and-health-management/\", \"https://www.linkedin.com/pulse/ai-startup-pre-seed-funding-analysis-usa-uk-europe-2024-2025-ahmed-jddhf\", \"https://www.crescendo.ai/news/latest-vc-investment-deals-in-ai-startups\", \"https://www.reddit.com/r/startups/comments/1fkns8w/behind_the_scene_fundraising_preseed_of_an_ai/\", \"https://news.crunchbase.com/venture/na-funding-q2-2025-ai-ipo-ma-data/\"]}",
    "Internal": [
      "user_data (3).csv - Product/Tech",
      "user_data (3).csv - Product/Tech",
      "user_data (3).csv - Product/Tech",
      "file-sample_150kB (1).pdf - Company Material"
    ]
  },
  "status_main": false,
  "type_json": "Data_sources"
}

export const fieldLevelDiagnostic =
{
  "userId": "272",
  "threadId": "3738",
  "step": 15,
  "status": "Pending",
  "prompt": "Proceed further",
  "response": "### Schema Validation:\nThe files you uploaded have been analyzed and field-level diagnostics have been performed. You should see the results (dataset coverage, outliers, and notes) in the right-side panel. Please review these diagnostics carefully and confirm that they look correct before we proceed to the Proposed Cleanup Plan.\n\nPlease take a moment to review the diagnostics and let me know if everything looks correct or if there are any changes needed.\n\nLooking forward to your confirmation!",
  "json_response": [
    {
      "dataset": "Reviews",
      "coverage": "100.0%",
      "outliers": "sentiment_score: 2 outliers",
      "notes": "Clean",
      "filename": "user_data%20%283%29.csv",
      "field_details": {
        "user_id": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 100,
          "outliers": 0,
          "outlier_examples": []
        },
        "timestamp": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "channel": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "message": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "intent": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        },
        "emotion": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "topic": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 7,
          "outliers": 0,
          "outlier_examples": []
        },
        "sentiment_score": {
          "coverage": "100.0%",
          "data_type": "float64",
          "unique_values": 31,
          "outliers": 2,
          "outlier_examples": [
            0.8,
            0.84
          ]
        },
        "reply_status": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        }
      }
    },
    {
      "dataset": "Reviews",
      "coverage": "100.0%",
      "outliers": "sentiment_score: 2 outliers",
      "notes": "Clean",
      "filename": "user_data%20%283%29.csv",
      "field_details": {
        "user_id": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 100,
          "outliers": 0,
          "outlier_examples": []
        },
        "timestamp": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "channel": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "message": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "intent": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        },
        "emotion": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "topic": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 7,
          "outliers": 0,
          "outlier_examples": []
        },
        "sentiment_score": {
          "coverage": "100.0%",
          "data_type": "float64",
          "unique_values": 31,
          "outliers": 2,
          "outlier_examples": [
            0.8,
            0.84
          ]
        },
        "reply_status": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        }
      }
    },
    {
      "dataset": "Reviews",
      "coverage": "100.0%",
      "outliers": "sentiment_score: 2 outliers",
      "notes": "Clean",
      "filename": "user_data%20%283%29.csv",
      "field_details": {
        "user_id": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 100,
          "outliers": 0,
          "outlier_examples": []
        },
        "timestamp": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "channel": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "message": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "intent": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        },
        "emotion": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "topic": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 7,
          "outliers": 0,
          "outlier_examples": []
        },
        "sentiment_score": {
          "coverage": "100.0%",
          "data_type": "float64",
          "unique_values": 31,
          "outliers": 2,
          "outlier_examples": [
            0.8,
            0.84
          ]
        },
        "reply_status": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        }
      }
    },
    {
      "dataset": "Reviews",
      "coverage": "100.0%",
      "outliers": "sentiment_score: 2 outliers",
      "notes": "Clean",
      "filename": "user_data%20%283%29.csv",
      "field_details": {
        "user_id": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 100,
          "outliers": 0,
          "outlier_examples": []
        },
        "timestamp": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "channel": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "message": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "intent": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        },
        "emotion": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "topic": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 7,
          "outliers": 0,
          "outlier_examples": []
        },
        "sentiment_score": {
          "coverage": "100.0%",
          "data_type": "float64",
          "unique_values": 31,
          "outliers": 2,
          "outlier_examples": [
            0.8,
            0.84
          ]
        },
        "reply_status": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        }
      }
    },
    {
      "dataset": "Reviews",
      "coverage": "100.0%",
      "outliers": "sentiment_score: 2 outliers",
      "notes": "Clean",
      "filename": "user_data%20%283%29.csv",
      "field_details": {
        "user_id": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 100,
          "outliers": 0,
          "outlier_examples": []
        },
        "timestamp": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "channel": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "message": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 149,
          "outliers": 0,
          "outlier_examples": []
        },
        "intent": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        },
        "emotion": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 6,
          "outliers": 0,
          "outlier_examples": []
        },
        "topic": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 7,
          "outliers": 0,
          "outlier_examples": []
        },
        "sentiment_score": {
          "coverage": "100.0%",
          "data_type": "float64",
          "unique_values": 31,
          "outliers": 2,
          "outlier_examples": [
            0.8,
            0.84
          ]
        },
        "reply_status": {
          "coverage": "100.0%",
          "data_type": "object",
          "unique_values": 4,
          "outliers": 0,
          "outlier_examples": []
        }
      }
    },
    {
      "dataset": "Document",
      "coverage": "95.0%",
      "outliers": "4 content anomalies",
      "notes": "The document has a high-quality score of 95.0%, indicating overall good quality. However, readability may be impacted by the presence of four long sentences. Breaking these sentences into shorter, more digestible parts could improve clarity and reader engagement. Content appears well-structured with no other notable issues.",
      "filename": "file-sample_150kB%20%281%29.pdf"
    }
  ],
  "status_main": false,
  "type_json": "schema_validation_field_level_diagnostic"
}

export const dataSourceInvestment = {
    "userId": "272",
    "threadId": "3751",
    "step": 19,
    "status": "Pending",
    "prompt": "Proceed further",
    "response": "Great! Let's move on to the next step.\n\n### Showcase Data Sources\n\nBased on the details gathered, here are some \nRefer to the right-hand side for further details\n. Feel free to add or suggest others.\n\nPlease review these queries and confirm if they look good to proceed. If you need any adjustments or have other suggestions, let me know!",
    "json_response": {
        "External sources": "{\"Website\": [\"https://devabit.com/blog/top-11-new-technologies-in-ai-exploring-the-latest-trends/\", \"https://cloud.google.com/resources/ai-trends-report\", \"https://www.gao.gov/blog/artificial-intelligences-use-and-rapid-growth-highlight-its-possibilities-and-perils\", \"https://today.ucsd.edu/story/7-ai-powered-technologies-you-should-know-about\", \"https://www.skyquestt.com/report/beauty-tech-market\", \"https://osf.digital/library/blog/beauty-tech-key-insights-and-trends-for-2025\", \"https://www.thebusinessresearchcompany.com/report/beauty-tech-global-market-report\", \"https://www.grandviewresearch.com/industry-analysis/beauty-tech-market-report\", \"https://www.qcmakeupacademy.com/blog/2024/11/15-beauty-tech-software-revolutionizing-the-makeup-industry\", \"https://gonative.ai/post/beauty-industry-competitive-analysis\", \"https://ecomundo.eu/en/blog/beauty-tech-2025\", \"https://arbelle.ai/cosmetics-industry-report/\", \"https://explodingtopics.com/blog/beauty-trends\", \"https://www.askattest.com/blog/articles/beauty-industry-trends\", \"https://www.withorb.com/blog/ai-pricing-models\", \"https://www.infracloud.io/blogs/ai-workload-cost-optimization/\", \"https://cloud.google.com/transform/three-proven-strategies-for-optimizing-ai-costs\", \"https://www.coherentsolutions.com/insights/ai-development-cost-estimation-pricing-structure-roi\", \"https://zylo.com/blog/ai-cost/\", \"https://www.cloudzero.com/blog/ai-cost-optimization/\", \"https://www.hyperline.co/resources/blog/ai-pricing-strategies\", \"https://www.techtarget.com/searchenterpriseai/tip/Reduce-project-expenses-with-AI-cost-optimization-strategies\", \"https://pilot.com/blog/ai-pricing-economics-2025\", \"https://blog.equinix.com/blog/2025/01/08/how-ai-is-influencing-data-center-infrastructure-trends-in-2025/\", \"https://technologyblog.rsmus.com/technologies/microsoft/maximizing-efficiency-and-roi-in-ai-initiatives-a-guide-to-cost-optimization/\", \"https://www.infosys.com/services/data-ai-topaz/insights/ai-best-practices-cost-optimization.pdf\", \"https://medium.com/cloud-experts-hub/generative-ai-infrastructure-costs-a-practical-guide-to-gcp-azure-aws-and-beyond-fafb2808b1af\", \"https://springsapps.com/knowledge/ai-development-cost-in-2024-real-examples-and-trends\"],\"Publication\": [\"https://www.statista.com/outlook/tmo/artificial-intelligence/worldwide\", \"https://www.morganstanley.com/insights/articles/ai-trends-reasoning-frontier-models-2025-tmt\", \"https://www.pwc.com/gx/en/issues/artificial-intelligence/ai-jobs-barometer.html\", \"https://online-engineering.case.edu/blog/advancements-in-artificial-intelligence-and-machine-learning\", \"https://www.statista.com/study/116101/beauty-tech/\", \"https://www.grandviewresearch.com/horizon/outlook/beauty-tech-market/united-states\", \"https://www.factmr.com/report/tech-enhanced-cosmetics-market\", \"https://www.statista.com/outlook/emo/beauty-personal-care/beauty-tech/worldwide\", \"https://www.statista.com/outlook/cmo/beauty-personal-care/beauty-tech/worldwide\", \"https://www.mckinsey.com/industries/consumer-packaged-goods/our-insights/state-of-beauty\", \"https://www.mckinsey.com/industries/consumer-packaged-goods/our-insights/the-beauty-boom-and-beyond-can-the-industry-maintain-its-growth\", \"https://www.cloudzero.com/state-of-ai-costs/\", \"https://www.mckinsey.com/industries/technology-media-and-telecommunications/our-insights/the-cost-of-compute-a-7-trillion-dollar-race-to-scale-data-centers\", \"https://hai.stanford.edu/ai-index/2025-ai-index-report\", \"https://www.deloitte.com/us/en/insights/industry/power-and-utilities/data-center-infrastructure-artificial-intelligence.html\"],\"Scholar\": [\"https://ep.jhu.edu/news/advancements-in-ai-and-machine-learning/\", \"https://hai.stanford.edu/ai-index/2025-ai-index-report\", \"https://hai.stanford.edu/ai-index/2025-ai-index-report\"],\"News\": [\"https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/the-top-trends-in-tech\", \"https://news.microsoft.com/source/features/ai/6-ai-trends-youll-see-more-of-in-2025/\", \"https://www.mckinsey.com/capabilities/quantumblack/our-insights/the-state-of-ai\", \"https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/superagency-in-the-workplace-empowering-people-to-unlock-ais-full-potential-at-work\", \"https://unctad.org/news/ai-market-projected-hit-48-trillion-2033-emerging-dominant-frontier-technology\", \"https://www.brookings.edu/articles/how-artificial-intelligence-is-transforming-the-world/\", \"https://www.gcimagazine.com/brands-products/devices-tech/news/22934515/the-beauty-tech-boom-personalized-solutions-driving-market-expansion\", \"https://www.spglobal.com/market-intelligence/en/news-insights/research/ai-infrastructure-trends-thoughts-and-a-2025-research-agenda\", \"https://isg-one.com/articles/ai-powered-cost-optimization--how-smart-companies-are-slashing-expenses-and-boosting-efficiency-in-2025\"]}",
        "Internal": [
            "user_data (3).csv - Financials",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "user_data (3).csv - Product/Tech",
            "file-sample_150kB (1).pdf - Company Material"
        ]
    },
    "status_main": false,
    "type_json": "Data_sources"
}